import React, { useEffect, useRef } from 'react';
import Webcam from 'react-webcam';

import PropTypes from 'prop-types';

const Scanner = ({ onScan, isScanning, isPaused, intervalMs, ...props }) => {
	const webcamRef = useRef(null);

	const cancelIntervalRef = useRef();

	const capture = React.useCallback(
		(...args) => webcamRef.current && webcamRef.current.getScreenshot(...args),
		[webcamRef]
	);

	useEffect(() => {
		if (isPaused) {
			webcamRef.current?.video.pause();
		} else {
			webcamRef.current?.video.play();
		}
	}, [isPaused]);

	useEffect(() => {
		if (cancelIntervalRef.current) {
			cancelIntervalRef.current(); // if we're running this again for any reason we don't want the previous interval to interfere
		}

		const scan = () => {
			const img = capture();
			if (img) {
				onScan(img);
			}
		};

		if (isScanning) {
			scan();
			const interval = setInterval(async () => {
				scan();
			}, intervalMs);

			cancelIntervalRef.current = () => clearInterval(interval);
			return () => cancelIntervalRef.current();
		}
		return () => {};
	}, [webcamRef, onScan, isScanning, capture, intervalMs]);

	return (
		<Webcam
			audio={false}
			imageSmoothing={false}
			forceScreenshotSourceSize
			screenshotFormat="image/jpeg"
			ref={webcamRef}
			videoConstraints={{ facingMode: 'environment' }}
			{...props}
		/>
	);
};

Scanner.propTypes = {
	isPaused: PropTypes.bool,
	intervalMs: PropTypes.number,
};

Scanner.defaultProps = {
	isPaused: false,
	intervalMs: 75,
};

export default Scanner;
